import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { cn } from "@/lib/utils";

interface ClientFilterProps {
  sortBy: string;
  onSortChange: (value: string) => void;
  filterPlan: string;
  onFilterChange: (plan: string) => void;
  planCounts: Record<string, number>;
  totalClients: number;
}

const SORT_LABELS: Record<string, string> = {
  alphabetical_asc: "A-Z",
  alphabetical_desc: "Z-A",
  newest_first: "Newest",
  oldest_first: "Oldest",
};

export default function ClientFilter({
  sortBy,
  onSortChange,
  filterPlan,
  onFilterChange,
  planCounts,
  totalClients,
}: ClientFilterProps) {
  const sortedPlans = Object.entries(planCounts).sort(([aName], [bName]) => {
    if (aName === "Inactive") return -1;
    if (bName === "Inactive") return 1;
    return aName.localeCompare(bName);
  });

  return (
    <div className="flex w-full max-w-[280px] flex-col gap-3 lg:w-[280px]">
      <div className="flex flex-col gap-1">
        <p className="text-sm leading-6 font-bold -tracking-wide">Sort:</p>
        <Select onValueChange={onSortChange} value={sortBy}>
          <SelectTrigger className="text-black-300 bg-admin-input !h-[45px] w-full !px-5 !py-3 text-sm leading-normal font-medium">
            <SelectValue>{SORT_LABELS[sortBy]}</SelectValue>
          </SelectTrigger>
          <SelectContent className="!text-black-300 bg-admin-input">
            <SelectItem value="alphabetical_asc" className="!text-black-300">
              A-Z
            </SelectItem>
            <SelectItem value="alphabetical_desc" className="!text-black-300">
              Z-A
            </SelectItem>
            <SelectItem value="newest_first" className="!text-black-300">
              Newest
            </SelectItem>
            <SelectItem value="oldest_first" className="!text-black-300">
              Oldest
            </SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="flex flex-col gap-1">
        <p className="text-sm leading-6 font-bold -tracking-wide">
          Filter by plan:
        </p>
        <button
          onClick={() => onFilterChange("all")}
          className={cn(
            "flex w-full cursor-pointer flex-row items-center justify-between gap-2 rounded-lg px-5 py-2 text-sm leading-normal font-medium transition-colors hover:bg-white/5",
            filterPlan === "all" && "bg-black-950",
          )}
        >
          <span>All</span>
          <span className="shrink-0 tabular-nums">{totalClients}</span>
        </button>
        {sortedPlans.map(([plan, count]) => (
          <button
            key={plan}
            onClick={() => onFilterChange(plan)}
            title={plan}
            className={cn(
              "flex w-full cursor-pointer flex-row items-center justify-between gap-2 rounded-lg px-5 py-2 text-left text-sm leading-normal font-medium transition-colors hover:bg-white/5",
              filterPlan === plan && "bg-black-950",
            )}
          >
            <span className="min-w-0 truncate" title={plan}>
              {plan}
            </span>
            <span className="shrink-0 tabular-nums">{count}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
